import moment from "moment/moment";
import formatCurrency from "format-currency";
import _ from "lodash";
import qbTransactionModal from "../../../common/modals/QbTransactionModal/qbTransactionModal.component";

const LABOR_CATEGORY_DEFINITIONS = [
  { name: 'Direct', color: '#3498db' },
  { name: 'Fringe', color: '#2ecc71' },
  { name: 'Overhead', color: '#f39c12' },
  { name: 'General & Administrative', color: '#9b59b6' },
  { name: 'B&P', color: '#e74c3c' }
];

class PayrollDetailsController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $stateParams, $uibModal) {
    "ngInject";
    this.name = 'customers';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.customers = [];
    this.generalLedger = [];
    this.taxLedger = [];
    this.retirementLedger = [];
    this.retirementContributionLedger = [];
    this.retirementLoanLedger = [];
    this.paycheckTableData = [];
    this.laborDistributionTableData = [];
    this.taxLedgerTableData = [];
    this.retirementContributionTableData = [];
    this.retirementLoanTableData = [];
    this.generalLedgerSummary = null;
    this.generalLedgerCategorySummaries = [];
    this.showUnclassifiedChargeCodes = true;
    this.matchingPayrollTransactions = [];
    this.matchingTaxTransactions = [];
    this.matchingRetirementContributionTransactions = [];
    this.matchingRetirementLoanTransactions = [];
    this.unmappedQbProjects = [];
    this.unmappedChargeCodes = [];
    this.unmappedRetirementContributionExpenseCodes = [];
    this.unmappedRetirementLoanExpenseCodes = [];
    this.qbPayrollMatchFailed = false;
    this.qbPayrollLookupPending = false;
    this.qbPayrollLookupError = null;
    this.showQbMatchInfoDiagnostics = false;
    this.exportingLaborToQb = false;
    this.exportingTaxToQb = false;
    this.exportingRetirementContributionToQb = false;
    this.exportingRetirementLoanToQb = false;

    let self = this;

    this.payrollCostCategoryOptions = [
      { value: 'DIRECT', text: 'Direct' },
      { value: 'FRINGE', text: 'Fringe' },
      { value: 'OVERHEAD', text: 'Overhead' },
      { value: 'GENERAL_ADMINISTRATIVE', text: 'General & Administrative' },
      { value: 'BID_AND_PROPOSAL', text: 'B&P' }
    ];

    this.paycheckColumns = [
      {
        displayName: 'First Name',
        value: 'firstName',
        sortable: true
      },
      {
        displayName: 'Last Name',
        value: 'lastName',
        sortable: true
      },
      {
        displayName: 'Hours',
        value: 'regularHours',
        sortable: true,
        dataType: 'number'
      },
      {
        displayName: 'Taxes',
        value: 'totalTaxes',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.totalTaxes);
        }
      },
      {
        displayName: 'Deductions',
        value: 'totalDeductions',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.totalDeductions);
        }
      },
      {
        displayName: 'Gross Pay',
        value: 'grossPay',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.grossPay);
        }
      },
      {
        displayName: 'Net Pay',
        value: 'netPay',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.netPay);
        }
      }
    ];

    this.laborDistributionColumns = [
      {
        displayName: 'Employee',
        value: 'employee',
        sortable: true
      },
      {
        displayName: 'Charge Code',
        value: 'chargeCode',
        sortable: true
      },
      {
        displayName: 'Contract',
        value: 'contract',
        sortable: true
      },
      {
        displayName: 'Project',
        value: 'project',
        sortable: true
      },
      {
        displayName: 'Hours',
        value: 'hours',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatHours(record.hours);
        }
      },
      {
        displayName: 'Cost',
        value: 'cost',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.cost);
        }
      }
    ];

    this.taxLedgerColumns = [
      {
        displayName: 'Description',
        value: 'description',
        sortable: true
      },
      {
        displayName: 'Cost',
        value: 'cost',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.cost);
        }
      }
    ];

    this.retirementLedgerColumns = [
      {
        displayName: 'Description',
        value: 'description',
        sortable: true
      },
      {
        displayName: 'Cost',
        value: 'cost',
        sortable: true,
        dataType: 'number',
        formatting: function (record) {
          return self.formatDollars(record.cost);
        }
      }
    ];

    if($stateParams.payrollId) {
      this.$http.get($rootScope.apiHost+"/api/admin/payroll/"+$stateParams.payrollId, {withCredentials: true}).then(function (success) {
          self.payroll = success.data;
          self.paycheckTableData = self.buildPaycheckTableData(self.payroll.paychecks);

          self.$http.get($rootScope.apiHost+"/api/admin/payroll/"+$stateParams.payrollId+"/general-ledger", {withCredentials: true}).then(function (success) {
            let payload = success.data || {};
            self.generalLedger = payload.entries || [];
            self.generalLedgerSummary = payload.summary || null;
            self.buildGeneralLedgerCategorySummaries(self.generalLedgerSummary);
            self.laborDistributionTableData = self.buildLaborDistributionTableData(self.generalLedger);

            let y = self.payroll.checkDate;

            let total = 0;
            self.generalLedger.forEach(function (entry) {
              total = total + entry.cost;
            });

            const lookupAmount = (self.generalLedgerSummary
              && typeof self.generalLedgerSummary.ledgerTotal === 'number')
              ? self.generalLedgerSummary.ledgerTotal
              : total;

            self.unmappedQbProjects = Object.keys(self.findUnmappedProjects());
            self.unmappedChargeCodes = Object.keys(self.findChargeCodesWithoutMappedAccounts());

            self.qbPayrollLookupPending = true;
            self.qbPayrollMatchFailed = false;
            self.qbPayrollLookupError = null;

            self.$http.get(
              $rootScope.apiHost + "/api/integrations/qb/transactions?transactionDate=" + y + "&amount=" + lookupAmount.toFixed(2),
              { withCredentials: true }
            ).then(function (success) {
              self.matchingPayrollTransactions = success.data || [];
              self.qbPayrollMatchFailed = !self.matchingPayrollTransactions.length
                || self.hasUnequalQbMatchAmounts(self.matchingPayrollTransactions, lookupAmount);
              self.qbPayrollLookupPending = false;
            }, function (failure) {
              self.matchingPayrollTransactions = [];
              self.qbPayrollMatchFailed = true;
              self.qbPayrollLookupPending = false;
              self.qbPayrollLookupError = (failure && failure.status === 404)
                ? 'No QuickBooks purchase matched the labor distribution total.'
                : 'QuickBooks transaction lookup failed.';
            });
          }, function (failure) {
            console.log(failure.data);
          });

          self.$http.get($rootScope.apiHost+"/api/admin/payroll/"+$stateParams.payrollId+"/tax-ledger", {withCredentials: true}).then(function (success) {
            self.taxLedger = success.data;
            self.taxLedgerTableData = self.buildTaxLedgerTableData(self.taxLedger);

            let y = self.payroll.checkDate;

            let total = 0;
            self.taxLedger.forEach( function (entry) {
              total = total + entry.cost;
            });

            self.$http.get($rootScope.apiHost+"/api/integrations/qb/transactions?transactionDate="+y+"&amount="+total.toFixed(2), {withCredentials: true}).then(function (success) {
              self.matchingTaxTransactions = success.data || [];
            }, function () {
              self.matchingTaxTransactions = [];
            });

          });


          self.$http.get($rootScope.apiHost+"/api/admin/payroll/"+$stateParams.payrollId+"/retirement-ledger", {withCredentials: true}).then(function (success) {
            self.retirementLedger = success.data || [];
            self.splitRetirementLedgers(self.retirementLedger);
            self.retirementContributionTableData = self.buildRetirementLedgerTableData(self.retirementContributionLedger);
            self.retirementLoanTableData = self.buildRetirementLedgerTableData(self.retirementLoanLedger);
            self.unmappedRetirementContributionExpenseCodes = Object.keys(
              self.findRetirementExpenseCodesWithoutMappedAccounts(self.retirementContributionLedger));
            self.unmappedRetirementLoanExpenseCodes = Object.keys(
              self.findRetirementExpenseCodesWithoutMappedAccounts(self.retirementLoanLedger));

            let y = self.payroll.checkDate;
            self.lookupRetirementQbMatch('contribution', y, self.getRetirementGroupTotal(self.retirementContributionLedger));
            self.lookupRetirementQbMatch('loan', y, self.getRetirementGroupTotal(self.retirementLoanLedger));
          });



        },
        function (failure) {
          $state.go("notfound");
        });
    } else {
      $state.go("notfound");
    }


  }


  findUnmappedProjects() {
    let unmappedProjects = {};
    this.generalLedger.forEach(function (entry) {
      if(!entry.payrollLiabilty && entry.billable && entry.qbProjectId === null) {
        unmappedProjects[entry.project] = 1;
      }
    });

    return unmappedProjects;
  }


  findChargeCodesWithoutMappedAccounts() {
    let unmappedChargeCodes = {};
    this.generalLedger.forEach(function (entry) {
      if(entry.qbAccountId === null) {
        unmappedChargeCodes[entry.chargeCode] = 1;
      }
    });

    return unmappedChargeCodes;
  }

  findRetirementExpenseCodesWithoutMappedAccounts(ledger) {
    let self = this;
    let unmappedExpenseCodes = {};
    (ledger || []).forEach(function (entry) {
      if (entry.qbAccountId === null || entry.qbAccountId === undefined) {
        unmappedExpenseCodes[self.getRetirementExpenseLabel(entry)] = 1;
      }
    });

    return unmappedExpenseCodes;
  }

  isRetirementLoanPayment(entry) {
    if (!entry) {
      return false;
    }
    if (entry.retirementLoanPayment === true) {
      return true;
    }
    let code = entry.detailCode || '';
    if (!code && entry.chargeCode) {
      let match = String(entry.chargeCode).trim().match(/^401L\d+/i);
      code = match ? match[0] : '';
    }
    return /^401L\d+$/i.test(String(code).trim());
  }

  splitRetirementLedgers(retirementLedger) {
    let self = this;
    this.retirementContributionLedger = [];
    this.retirementLoanLedger = [];
    (retirementLedger || []).forEach(function (entry) {
      if (self.isRetirementLoanPayment(entry)) {
        self.retirementLoanLedger.push(entry);
      } else {
        self.retirementContributionLedger.push(entry);
      }
    });
  }

  getRetirementGroupTotal(ledger) {
    let total = 0;
    (ledger || []).forEach(function (entry) {
      total = total + (entry.cost || 0);
    });
    return total;
  }

  hasRetirementContributionGroup() {
    return this.getRetirementGroupTotal(this.retirementContributionLedger) > 0;
  }

  hasRetirementLoanGroup() {
    return this.getRetirementGroupTotal(this.retirementLoanLedger) > 0;
  }

  lookupRetirementQbMatch(group, checkDate, total) {
    let self = this;
    let matchingKey = group === 'loan'
      ? 'matchingRetirementLoanTransactions'
      : 'matchingRetirementContributionTransactions';

    if (!total || total <= 0 || !checkDate) {
      self[matchingKey] = [];
      return;
    }

    self.$http.get(self.$rootScope.apiHost + "/api/integrations/qb/transactions?transactionDate="
      + checkDate + "&amount=" + total.toFixed(2) + "&afterDate=true", {withCredentials: true}).then(function (success) {
      self[matchingKey] = success.data || [];
    }, function () {
      self[matchingKey] = [];
    });
  }

  isEmployerRetirementExpense(entry) {
    if (entry.employerResponsibilityFlag != null) {
      return !!entry.employerResponsibilityFlag;
    }

    return !!entry.employerResponsible;
  }

  getRetirementResponsibilityLabel(entry) {
    return this.isEmployerRetirementExpense(entry) ? 'Employer' : 'Employee';
  }

  getRetirementExpenseLabel(entry) {
    if (entry.chargeCode) {
      return entry.chargeCode;
    }

    let parts = [];
    if (entry.detailCode) {
      parts.push(entry.detailCode);
    }
    if (entry.detailType) {
      parts.push(entry.detailType);
    }
    parts.push(this.getRetirementResponsibilityLabel(entry));
    return parts.join(' - ');
  }


  exportLedgerToQb(txid) {
    let self = this;
    const transactionId = txid || this.getQbTransactionId(this.matchingPayrollTransactions[0]);
    if (!transactionId || this.exportingLaborToQb) {
      return;
    }
    if (this.unmappedQbProjects && this.unmappedQbProjects.length) {
      this.toastr.warning('Map all QuickBooks projects before exporting labor distribution.', 'Cannot Export');
      return;
    }

    this.exportingLaborToQb = true;
    self.$http.post(self.$rootScope.apiHost+"/api/integrations/qb/transactions/"+transactionId+"/general",  self.generalLedger, {withCredentials: true}).then(function () {
      self.toastr.success("Successfully exported Labor Distribution to QuickBooks.", "Success");
    }, function (failure) {
      const message = (failure.data && (failure.data.message || failure.data.error))
        || 'Could not export Labor Distribution to QuickBooks.';
      self.toastr.error(message, 'ERROR');
    }).finally(function () {
      self.exportingLaborToQb = false;
    });
  }

  exportTaxLedgerToQb(txid) {
    let self = this;
    const transactionId = txid || this.getQbTransactionId(this.matchingTaxTransactions[0]);
    if (!transactionId || this.exportingTaxToQb) {
      return;
    }

    this.exportingTaxToQb = true;
    self.$http.post(self.$rootScope.apiHost+"/api/integrations/qb/transactions/"+transactionId+"/taxes",  self.taxLedger, {withCredentials: true}).then(function () {
      self.toastr.success("Successfully exported Tax Distribution to QuickBooks.", "Success");
    }, function (failure) {
      const message = (failure.data && (failure.data.message || failure.data.error))
        || 'Could not export Tax Distribution to QuickBooks.';
      self.toastr.error(message, 'ERROR');
    }).finally(function () {
      self.exportingTaxToQb = false;
    });
  }

  exportRetirementContributionLedgerToQb(txid) {
    let self = this;
    const transactionId = txid || this.getQbTransactionId(this.matchingRetirementContributionTransactions[0]);
    if (!transactionId || this.exportingRetirementContributionToQb) {
      return;
    }
    if (this.unmappedRetirementContributionExpenseCodes && this.unmappedRetirementContributionExpenseCodes.length) {
      this.toastr.warning('Map all retirement contribution expense codes before exporting.', 'Cannot Export');
      return;
    }

    this.exportingRetirementContributionToQb = true;
    self.$http.post(self.$rootScope.apiHost+"/api/integrations/qb/transactions/"+transactionId+"/retirement",
      self.retirementContributionLedger, {withCredentials: true}).then(function () {
      self.toastr.success("Successfully exported Retirement Contributions to QuickBooks.", "Success");
    }, function (failure) {
      const message = (failure.data && (failure.data.message || failure.data.error))
        || 'Could not export Retirement Contributions to QuickBooks.';
      self.toastr.error(message, 'ERROR');
    }).finally(function () {
      self.exportingRetirementContributionToQb = false;
    });
  }

  exportRetirementLoanLedgerToQb(txid) {
    let self = this;
    const transactionId = txid || this.getQbTransactionId(this.matchingRetirementLoanTransactions[0]);
    if (!transactionId || this.exportingRetirementLoanToQb) {
      return;
    }
    if (this.unmappedRetirementLoanExpenseCodes && this.unmappedRetirementLoanExpenseCodes.length) {
      this.toastr.warning('Map all 401k loan expense codes before exporting.', 'Cannot Export');
      return;
    }

    this.exportingRetirementLoanToQb = true;
    self.$http.post(self.$rootScope.apiHost+"/api/integrations/qb/transactions/"+transactionId+"/retirement",
      self.retirementLoanLedger, {withCredentials: true}).then(function () {
      self.toastr.success("Successfully exported 401k Loan Payments to QuickBooks.", "Success");
    }, function (failure) {
      const message = (failure.data && (failure.data.message || failure.data.error))
        || 'Could not export 401k Loan Payments to QuickBooks.';
      self.toastr.error(message, 'ERROR');
    }).finally(function () {
      self.exportingRetirementLoanToQb = false;
    });
  }

  getQbTransactionId(transaction) {
    if (!transaction) {
      return null;
    }
    return transaction.Id || transaction.id || null;
  }

  viewQbTransaction(transactionOrId) {
    const transactionId = typeof transactionOrId === 'object'
      ? this.getQbTransactionId(transactionOrId)
      : transactionOrId;
    if (!transactionId) {
      return;
    }

    const modalInstance = this.$uibModal.open(qbTransactionModal);
    modalInstance.transactionId = transactionId;
    modalInstance.cancel = function () {
      modalInstance.dismiss('cancel');
    };
  }

  hasMatchingPayrollTransaction() {
    return !!(this.matchingPayrollTransactions && this.matchingPayrollTransactions.length
      && this.getQbTransactionId(this.matchingPayrollTransactions[0]));
  }

  hasMatchingTaxTransaction() {
    return !!(this.matchingTaxTransactions && this.matchingTaxTransactions.length
      && this.getQbTransactionId(this.matchingTaxTransactions[0]));
  }

  hasMatchingRetirementContributionTransaction() {
    return !!(this.matchingRetirementContributionTransactions && this.matchingRetirementContributionTransactions.length
      && this.getQbTransactionId(this.matchingRetirementContributionTransactions[0]));
  }

  hasMatchingRetirementLoanTransaction() {
    return !!(this.matchingRetirementLoanTransactions && this.matchingRetirementLoanTransactions.length
      && this.getQbTransactionId(this.matchingRetirementLoanTransactions[0]));
  }

  canExportLaborToQb() {
    return this.hasMatchingPayrollTransaction()
      && (!this.unmappedQbProjects || !this.unmappedQbProjects.length);
  }

  canExportTaxToQb() {
    return this.hasMatchingTaxTransaction();
  }

  canExportRetirementContributionToQb() {
    return this.hasMatchingRetirementContributionTransaction()
      && (!this.unmappedRetirementContributionExpenseCodes || !this.unmappedRetirementContributionExpenseCodes.length);
  }

  canExportRetirementLoanToQb() {
    return this.hasMatchingRetirementLoanTransaction()
      && (!this.unmappedRetirementLoanExpenseCodes || !this.unmappedRetirementLoanExpenseCodes.length);
  }


  currency(value) {
    return formatCurrency(value);
  }

  formatDollars(value) {
    if (typeof value !== 'number') {
      return undefined;
    }

    return new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' }).format(value);
  }

  formatHours(value) {
    if (typeof value !== 'number' || !isFinite(value)) {
      return '';
    }

    return value.toFixed(2);
  }

  formatCheckDate(value) {
    if (!value) {
      return '—';
    }

    return moment(value).format('MMM D, YYYY');
  }

  buildGeneralLedgerCategorySummaries(summary) {
    if (!summary || !summary.costByCategory) {
      this.generalLedgerCategorySummaries = [];
      return;
    }

    let totalLaborCost = typeof summary.totalLaborCost === 'number' ? summary.totalLaborCost : 0;
    let costByCategory = summary.costByCategory;

    this.generalLedgerCategorySummaries = LABOR_CATEGORY_DEFINITIONS.map(function (definition) {
      let amount = costByCategory[definition.name] || 0;
      let percentage = totalLaborCost > 0 ? (amount / totalLaborCost) * 100 : 0;

      return {
        name: definition.name,
        amount: amount,
        color: definition.color,
        percentage: percentage
      };
    });
  }

  formatPercentage(value) {
    if (typeof value !== 'number' || !isFinite(value)) {
      return '0.0%';
    }

    return value.toFixed(1) + '%';
  }

  hasUnclassifiedLaborCost() {
    return this.generalLedgerSummary
      && typeof this.generalLedgerSummary.unclassifiedLaborCost === 'number'
      && this.generalLedgerSummary.unclassifiedLaborCost > 0;
  }

  getUnclassifiedChargeCodes() {
    if (!this.generalLedgerSummary || !this.generalLedgerSummary.unclassifiedChargeCodes) {
      return [];
    }
    return this.generalLedgerSummary.unclassifiedChargeCodes;
  }

  getQbMatchDiagnostics() {
    if (!this.generalLedgerSummary || !this.generalLedgerSummary.qbMatchDiagnostics) {
      return [];
    }
    return this.generalLedgerSummary.qbMatchDiagnostics;
  }

  shouldShowQbMatchDiagnostics() {
    return !!this.qbPayrollMatchFailed && !this.qbPayrollLookupPending;
  }

  hasUnequalQbMatchAmounts(transactions, expectedAmount) {
    if (!transactions || !transactions.length || typeof expectedAmount !== 'number') {
      return false;
    }

    return !transactions.some(function (txn) {
      const txnAmount = txn && (txn.TotalAmt != null ? txn.TotalAmt : txn.totalAmt);
      if (typeof txnAmount !== 'number') {
        return false;
      }
      return Math.abs(txnAmount - expectedAmount) <= 0.05;
    });
  }

  getPrimaryQbDiagnostics() {
    return this.getQbMatchDiagnostics().filter(function (diagnostic) {
      const severity = String(diagnostic.severity || '').toUpperCase();
      return severity === 'WARNING' || severity === 'ERROR';
    });
  }

  getInfoQbDiagnostics() {
    return this.getQbMatchDiagnostics().filter(function (diagnostic) {
      const severity = String(diagnostic.severity || '').toUpperCase();
      const code = String(diagnostic.code || '').toUpperCase();
      return severity === 'INFO' && code !== 'NO_KNOWN_MISMATCH_CAUSES';
    });
  }

  getNoKnownMismatchDiagnostic() {
    return this.getQbMatchDiagnostics().find(function (diagnostic) {
      return String(diagnostic.code || '').toUpperCase() === 'NO_KNOWN_MISMATCH_CAUSES';
    }) || null;
  }

  shouldShowNoKnownMismatchMessage() {
    const diagnostics = this.getQbMatchDiagnostics();
    if (!diagnostics.length) {
      return true;
    }
    return diagnostics.length === 1
      && String(diagnostics[0].code || '').toUpperCase() === 'NO_KNOWN_MISMATCH_CAUSES';
  }

  isUnmappedPaylocityDiagnostic(diagnostic) {
    return !!diagnostic
      && String(diagnostic.code || '').toUpperCase() === 'UNMAPPED_PAYLOCITY_EMPLOYEES';
  }

  formatDiagnosticItem(item) {
    if (!item) {
      return '';
    }

    let label = item.name || 'Unknown';
    if (item.paylocityEmployeeId != null) {
      label += ' (Paylocity ID: ' + item.paylocityEmployeeId + ')';
    }
    if (typeof item.amount === 'number') {
      label += ' — ' + this.formatDollars(item.amount);
    }
    if (item.detail) {
      label += ' — ' + item.detail;
    }
    return label;
  }

  buildPaycheckTableData(paychecks) {
    let self = this;
    return (paychecks || []).map(function (check) {
      let user = check.user || {};
      let paycheckDetail = check.paycheckDetail || [];
      return {
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        regularHours: check.regularHours,
        totalTaxes: self.sumPaycheckDetailByType(paycheckDetail, 'T'),
        totalDeductions: self.sumPaycheckDetailByType(paycheckDetail, 'D'),
        grossPay: check.grossPay,
        netPay: check.netPay
      };
    });
  }

  buildLaborDistributionTableData(generalLedger) {
    return (generalLedger || []).map(function (entry) {
      return {
        employee: entry.employee || '',
        chargeCode: entry.chargeCode || '',
        contract: entry.contract || '',
        project: entry.project || '',
        hours: entry.hours,
        cost: entry.cost
      };
    });
  }

  buildTaxLedgerTableData(taxLedger) {
    return (taxLedger || []).map(function (entry) {
      return {
        description: entry.chargeCode || '',
        cost: entry.cost
      };
    });
  }

  buildRetirementLedgerTableData(retirementLedger) {
    let self = this;
    return (retirementLedger || []).map(function (entry) {
      return {
        description: self.getRetirementExpenseLabel(entry),
        cost: entry.cost
      };
    });
  }

  normalizePaycheckDetailLine(detail) {
    if (!detail) {
      return detail;
    }

    return Object.assign({}, detail, {
      detail: detail.detail != null ? detail.detail : detail.det,
      detailCode: detail.detailCode != null ? detail.detailCode : detail.detCode,
      detailType: detail.detailType != null ? detail.detailType : detail.detType,
      amount: detail.amount != null ? detail.amount : 0
    });
  }

  sumPaycheckDetailByType(paycheckDetail, detailType) {
    let total = 0;
    let self = this;

    (paycheckDetail || []).forEach(function (line) {
      let normalized = self.normalizePaycheckDetailLine(line);
      if (normalized.detail === detailType) {
        total += normalized.amount || 0;
      }
    });

    return total;
  }

  getTotalTaxLedgerValue() {
    let total = 0;
    this.taxLedger.forEach( function (entry) {
      total = total + entry.cost;
    });

    return this.currency(total);
  }

  getTotalRetirementLedgerValue() {
    return this.currency(this.getRetirementGroupTotal(this.retirementLedger));
  }

  getTotalRetirementContributionLedgerValue() {
    return this.currency(this.getRetirementGroupTotal(this.retirementContributionLedger));
  }

  getTotalRetirementLoanLedgerValue() {
    return this.currency(this.getRetirementGroupTotal(this.retirementLoanLedger));
  }



  getTotalLedgerValue() {
    let total = 0;
    this.generalLedger.forEach( function (entry) {
      total = total + entry.cost;
    });

    return this.currency(total);
  }


}


export default PayrollDetailsController;



// WEBPACK FOOTER //
// ./client/pages/admin/payroll-details/payroll-details.controller.js